import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import AllowCookiesInterstitial from 'app/components/interstitials/AllowCookies';
import Body from 'app/components/layout/Body';
import AuthProvider from 'app/components/providers/AuthProvider';
import BankAccountStatusCheck from 'app/components/providers/BankAccountStatusCheck';
import ThirdPartyProviders from 'app/components/providers/ThirdPartyProviders';
import { useIsInIframe } from 'app/hooks';
import { PropsWithOnlyChildren } from 'app/types';

// Component Definition
export const MainLayout: FC<PropsWithOnlyChildren> = ({ children }) => {
  const { t } = useTranslation('components');
  const { isInIframe } = useIsInIframe();

  if (isInIframe) {
    return (
      <div>
        {t('mainLayout.iframeNotAllowed', 'iframe not allowed')}
      </div>
    );
  }

  return (
    <>
      <AllowCookiesInterstitial />

      <Body>
        <AuthProvider>
          <BankAccountStatusCheck>
            <ThirdPartyProviders>
              {children}
            </ThirdPartyProviders>
          </BankAccountStatusCheck>
        </AuthProvider>
      </Body>
    </>
  );
};
